import React from 'react';
import { navPermissionCheck } from '../../auth/authUtils';
import icons from '../../../constants/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation } from 'react-router-dom';
export interface OffCanvasTopMenuItemProps {
  currentUser: any;
  allowedPermissions?: string[];
  allowedUserTypes?: string[];
  isPowerUser?: boolean;
  onClick?: any;
  activeRegex?: string;
  activeif?: string;
  url: string;
  colour?: string;
  icon: any;
  title: string;
  children?: any;
}
function OffCanvasTopMenuItem({
  currentUser,
  allowedPermissions,
  allowedUserTypes,
  isPowerUser,
  onClick,
  activeRegex,
  activeif,
  url,
  colour,
  icon,
  title,
  children,
}: OffCanvasTopMenuItemProps) {
  const location = useLocation();
  let hasPermission = navPermissionCheck(
    currentUser,
    allowedPermissions,
    allowedUserTypes,
    isPowerUser
  );

  return hasPermission ? (
    <li
      onClick={onClick}
      className={`nav__menu-item ${activeRegex !== undefined
          ? `${location.pathname}${location.search}`.match(RegExp(activeRegex))
            ? 'is-current'
            : ''
          : `${location.pathname}${location.search}`.startsWith(
            activeif !== undefined ? activeif : url
          )
            ? 'is-current'
            : ''
        }`}
    >
      <div className="a nav-item">
        <span>
          <span className={`menu-icon-wrapper me-3 ${colour ?? ''}`}>
            <FontAwesomeIcon icon={icon} fixedWidth className="me-3" />
          </span>
          <span>{title}</span>
        </span>
        <span className="next-level-cta">
          <FontAwesomeIcon icon={icons.WIZARD_NEXT} />
        </span>
      </div>
      {children}
    </li>
  ) : (
    ''
  );
}

export default OffCanvasTopMenuItem;
